export default {
    // Header Section
    "discover_your": "మీ దాన్ని కనుగొనండి",
    "nature_report": "మీ జీవిత మార్గాన్ని ప్రభావితం చేసే వ్యక్తిత్వ లక్షణాల పూర్తి విశ్లేషణ",
    "natural_personality_insights": "సహజ వ్యక్తిత్వ అంతర్దృష్టులు",
    "nature_report_description": "సమగ్ర విశ్లేషణ ద్వారా మీ నిజమైన వ్యక్తిత్వం మరియు సహజ స్వభావాన్ని అర్థం చేసుకోండి. మీ జన్మ వివరాల ఆధారంగా మీ సహజ ప్రవర్తనా నమూనాలు, అంతర్గత బలాలు, ప్రాథమిక స్వభావం మరియు స్వీయ వ్యక్తీకరణ శైలిని తెలుసుకోండి.",

    // Service Information
    "enter_details_for_nature_analysis": "స్వభావ విశ్లేషణ కోసం మీ వివరాలను నమోదు చేయండి",
    "complete_nature_analysis": "పూర్ణ స్వభావ విశ్లేషణ",
    "service_price": "సేవా ధర",
    "comprehensive_nature_analysis_note": "మీ సహజ వ్యక్తిత్వం మరియు ప్రవర్తనా నమూనాల లోతైన విశ్లేషణ",

    // Form Fields
    "full_name": "పూర్తి పేరు",
    "enter_full_name": "మీ పూర్తి పేరును నమోదు చేయండి",
    "name_natural_vibration": "మీ పేరు మీ సహజ వ్యక్తిత్వ కంపనలతో ప్రతిధ్వనిస్తుంది",
    "email_address": "ఇమెయిల్ చిరునామా",
    "enter_email_address": "మీ ఇమెయిల్ చిరునామాను నమోదు చేయండి",
    "phone_number": "ఫోన్ నంబర్",
    "enter_phone_number": "మీ ఫోన్ నంబరును నమోదు చేయండి",
    "gender": "లింగం",
    "male": "పురుషుడు",
    "female": "స్త్రీ",
    "other": "ఇతర",
    "date_of_birth": "జన్మ తేదీ",
    "birth_date_personality_nature": "మీ సహజ వ్యక్తిత్వ లక్షణాలు మరియు మూలక స్వభావాన్ని నిర్ధారించడానికి అవసరం",
    "preferred_language": "ప్రాధాన్య భాష",
    "english": "ఇంగ్లీష్",
    "hindi": "హిందీ",
    "telugu": "తెలుగు",
    "kannada": "కన్నడ",
    "language_note": "మీ స్వభావ విశ్లేషణ ఎంచుకున్న భాషలో అందించబడుతుంది",

    // Core Nature Features
    "personality_traits_analysis": "వ్యక్తిత్వ లక్షణాల విశ్లేషణ",
    "behavioral_patterns_insights": "ప్రవర్తనా నమూనాల అంతర్దృష్టులు",
    "strengths_weaknesses_profile": "బలాలు మరియు బలహీనతల వివరణ",
    "natural_talents_discovery": "సహజ ప్రతిభల కనుగొనడం",
    "life_approach_guidance": "జీవిత దృక్పథ మార్గదర్శనం",
    "pdf_download": "సమగ్ర PDF నివేదిక",

    "what_you_get": "మీ స్వభావ విశ్లేషణలో ఉన్నవి",
    "comprehensive_personality_profile": "సమగ్ర వ్యక్తిత్వ వివరణ",
    "natural_behavior_patterns": "సహజ ప్రవర్తన నమూనాలు",
    "innate_talents_abilities": "సహజ ప్రతిభలు మరియు సామర్థ్యాలు",
    "personal_growth_guidance": "వ్యక్తిగత వృద్ధి మార్గదర్శనం",

    // Actions & Buttons
    "pay_and_generate_analysis": "నా స్వభావ విశ్లేషణ పొందండి",
    "processing_payment": "చెల్లింపును ప్రాసెస్ చేస్తోంది",
    "processing_request": "విశ్లేషణను రూపొందిస్తోంది",

    // Payment & Success Messages
    "thank_you": "ధన్యవాదాలు",
    "payment_successful": "చెల్లింపు విజయవంతం!",
    "nature_analysis_processing": "మీ స్వభావ విశ్లేషణ మా నిపుణ వ్యక్తిత్వ విశ్లేషకులచే తయారు చేయబడుతోంది. మీ సహజ వ్యక్తిత్వం మరియు ప్రవర్తనా నమూనాలపై వివరణాత్మక అంతర్దృష్టులు అందుకుంటారు.",
    "order_id": "ఆర్డర్ ID",
    "payment_id": "చెల్లింపు ID",
    "amount_paid": "చెల్లించిన మొత్తం",

    // Delivery Information
    "delivery_information": "డెలివరీ సమాచారం",
    "delivery_time": "విశ్లేషణ డెలివరీ",
    "within_8_hours_delivery_note": "మీ వివరణాత్మక స్వభావ నివేదిక 8 గంటలలోపు తయారవుతుంది",
    "whatsapp_notification": "వాట్సాప్ అప్‌డేట్‌లు",
    "whatsapp_delivery_note": "వాట్సాప్‌లో తక్షణ నోటిఫికేషన్‌లను అందుకోండి",
    "email_delivery": "ఇమెయిల్ డెలివరీ",
    "email_delivery_note": "పూర్తి విశ్లేషణ అందించబడుతుంది",

    // What You'll Receive
    "what_youll_receive": "మీ స్వభావ విశ్లేషణ ప్యాకేజ్",
    "detailed_nature_report": "సమగ్ర స్వభావ నివేదిక (PDF)",
    "personality_traits_breakdown": "వ్యక్తిత్వ లక్షణాల విభజన",
    "behavioral_insights_guide": "ప్రవర్తనా అంతర్దృష్టుల గైడ్",
    "natural_abilities_assessment": "సహజ సామర్థ్యాల అంచనా",
    "personal_development_roadmap": "వ్యక్తిగత అభివృద్ధి రోడ్‌మ్యాప్",

    // Visual Content
    "sample_nature_analysis": "నమూనా స్వభావ విశ్లేషణ",
    "dominant_nature_type": "ప్రధాన స్వభావ రకం",
    "sample_nature_reading": "బలమైన నాయకత్వ గుణాలతో సమతుల్య భూమి-అగ్ని స్వభావం",
    "sample_nature_preview": "మూలక అంతర్దృష్టులతో మీ వ్యక్తిగత స్వభావ విశ్లేషణ మునుజూపు",
    "nature_elements": "స్వభావ మూలకాలు",

    // Nature Element Types
    "fire": "అగ్ని",
    "water": "జలం",
    "earth": "భూమి",
    "air": "వాయువు",
    "ether": "ఆకాశం",
    "nature": "ప్రకృతి",

    // Status & Processing
    "your_nature_analysis_status": "మీ స్వభావ విశ్లేషణ స్థితి",
    "processing_your_analysis": "మీ సహజ వ్యక్తిత్వాన్ని విశ్లేషిస్తోంది",
    "analysis_processing_message": "మా వ్యక్తిత్వ నిపుణులు మీ ప్రామాణిక స్వభావం మరియు ప్రవర్తనా ధోరణులను నిర్ధారించడానికి మీ జన్మ నమూనాలను అధ్యయనం చేస్తున్నారు.",
    "request_id": "విశ్లేషణ ID",
    "status": "స్థితి",
    "processing": "ప్రగతిలో ఉంది",
    "pending": "వేచి ఉంది",
    "email_notification_sent": "నిర్ధారణ ఇమెయిల్ పంపబడింది",
    "whatsapp_update_coming": "వాట్సాప్ అప్‌డేట్‌లు ప్రారంభించబడ్డాయి",
    "delivery_within_8_hours": "8 గంటలలోపు నివేదిక సిద్ధం",

    // Support & Contact
    "contact_support": "స్వభావ మద్దతును సంప్రదించండి",
    "need_help": "మార్గదర్శనం కావాలా?",
    "contact_us_at": "మమ్మల్ని సంప్రదించండి",

    // Error Messages
    "please_fill_all_required_fields": "దయచేసి అవసరమైన అన్ని వివరాలను పూర్తి చేయండి",
    "payment_failed": "చెల్లింపు విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "processing_failed": "విశ్లేషణ ప్రాసెసింగ్ విఫలమైంది. మా మద్దతు బృందాన్ని సంప్రదించండి.",

    // Nature-Specific Elements
    "elemental_composition": "మూలక కలయిక",
    "dominant_element": "ప్రధాన మూలకం",
    "secondary_elements": "ద్వితీయ మూలకాలు",
    "elemental_balance": "మూలక సంతులనం",
    "natural_constitution": "సహజ రాజ్యాంగం",
    "temperament_type": "స్వభావ రకం",

    // Personality Traits
    "core_personality_traits": "ప్రధాన వ్యక్తిత్వ లక్షణాలు",
    "surface_personality": "ఉపరితల వ్యక్తిత్వం",
    "hidden_personality": "దాగిన వ్యక్తిత్వం",
    "authentic_self": "ప్రామాణిక స్వీయం",
    "personality_layers": "వ్యక్తిత్వ పొరలు",
    "character_essence": "వ్యక్తిత్వ సారం",

    // Behavioral Patterns
    "natural_reactions": "సహజ ప్రతిచర్యలు",
    "instinctive_responses": "సహజ ప్రవృత్తి స్పందనలు",
    "behavioral_tendencies": "ప్రవర్తనా ధోరణులు",
    "habitual_patterns": "అలవాటు నమూనాలు",
    "unconscious_behaviors": "అపస్మారక ప్రవర్తనలు",
    "automatic_responses": "స్వయంచాలక స్పందనలు",

    // Strengths & Abilities
    "natural_strengths": "సహజ బలాలు",
    "inherent_abilities": "సహజ సామర్థ్యాలు",
    "inborn_talents": "జన్మజాత ప్రతిభలు",
    "natural_gifts": "సహజ బహుమతులు",
    "core_competencies": "ప్రధాన సామర్థ్యాలు",
    "instinctive_skills": "సహజ ప్రవృత్తి నైపుణ్యాలు",

    // Weaknesses & Challenges
    "natural_weaknesses": "సహజ బలహీనతలు",
    "blind_spots": "వ్యక్తిత్వ అంధ ప్రాంతాలు",
    "growth_areas": "వృద్ధికి రంగాలు",
    "challenging_traits": "సవాలు లక్షణాలు",
    "limiting_patterns": "పరిమిత నమూనాలు",
    "shadow_aspects": "నీడ అంశాలు",

    // Temperament Types
    "sanguine_nature": "రక్తప్రధాన స్వభావం",
    "choleric_nature": "పిత్తప్రధాన స్వభావం",
    "melancholic_nature": "కఫప్రధాన దుఃఖ స్వభావం",
    "phlegmatic_nature": "కఫప్రధాన స్వభావం",
    "mixed_temperament": "మిశ్రమ స్వభావం",
    "temperament_blend": "స్వభావ మిశ్రమం",

    // Elemental Natures
    "fire_personality": "అగ్ని వ్యక్తిత్వం",
    "water_personality": "జల వ్యక్తిత్వం",
    "earth_personality": "భూమి వ్యక్తిత్వం",
    "air_personality": "వాయు వ్యక్తిత్వం",
    "space_personality": "ఆకాశ వ్యక్తిత్వం",
    "elemental_dominance": "మూలక ప్రాధాన్యత",

    // Interaction Styles
    "social_nature": "సామాజిక స్వభావం",
    "communication_style": "కమ్యూనికేషన్ శైలి",
    "interaction_preferences": "సంభాషణ ప్రాధాన్యతలు",
    "relationship_approach": "సంబంధ దృక్పథం",
    "conflict_style": "వివాద పరిష్కార శైలి",
    "leadership_nature": "నాయకత్వ స్వభావం",

    // Emotional Nature
    "emotional_patterns": "భావోద్వేగ నమూనాలు",
    "feeling_responses": "అనుభూతి స్పందనలు",
    "emotional_expression": "భావోద్వేగ వ్యక్తీకరణ",
    "mood_tendencies": "మానసిక స్థితి ధోరణులు",
    "emotional_intelligence": "భావోద్వేగ తెలివితేటలు",
    "sensitivity_levels": "సున్నితత్వ స్థాయిలు",

    // Mental Nature
    "thinking_patterns": "ఆలోచన నమూనాలు",
    "mental_approach": "మానసిక దృక్పథం",
    "cognitive_style": "జ్ఞానాత్మక శైలి",
    "learning_style": "అభ్యాస శైలి",
    "decision_making": "నిర్ణయం తీసుకునే శైలి",
    "problem_solving": "సమస్య పరిష్కార దృక్పథం",

    // Physical Nature
    "physical_constitution": "శారీరక రాజ్యాంగం",
    "energy_patterns": "శక్తి నమూనాలు",
    "activity_preferences": "కార్యకలాప ప్రాధాన్యతలు",
    "physical_expressions": "శారీరక వ్యక్తీకరణలు",
    "body_language": "సహజ శరీర భాష",
    "physical_tendencies": "శారీరక ధోరణులు",

    // Spiritual Nature
    "spiritual_inclinations": "ఆధ్యాత్మిక ప్రవృత్తులు",
    "inner_nature": "అంతర్గత స్వభావం",
    "soul_expression": "ఆత్మ వ్యక్తీకరణ",
    "spiritual_path": "సహజ ఆధ్యాత్మిక మార్గం",
    "divine_connection": "దైవిక సంబంధ శైలి",
    "transcendental_nature": "అతీంద్రియ స్వభావం",

    // Life Approach
    "life_philosophy": "సహజ జీవిత తత్వశాస్త్రం",
    "approach_to_challenges": "సవాళ్లకు దృక్పథం",
    "goal_orientation": "లక్ష్య దృష్టి",
    "success_definition": "విజయ నిర్వచనం",
    "life_priorities": "జీవిత ప్రాధాన్యతలు",
    "value_system": "ప్రధాన విలువల వ్యవస్థ",

    // Career Nature
    "work_style": "సహజ పని శైలి",
    "career_preferences": "కెరీర్ ప్రాధాన్యతలు",
    "professional_nature": "వృత్తిపరమైన స్వభావం",
    "workplace_behavior": "కార్యాలయ ప్రవర్తన",
    "team_dynamics": "జట్టు డైనామిక్స్",
    "professional_growth": "వృత్తిపరమైన వృద్ధి నమూనా",

    // Relationship Nature
    "relationship_style": "సంబంధ శైలి",
    "love_expression": "ప్రేమ వ్యక్తీకరణ",
    "friendship_patterns": "మిత్రత్వ నమూనాలు",
    "family_dynamics": "కుటుంబ డైనామిక్స్",
    "partnership_nature": "భాగస్వామ్య స్వభావం",
    "social_connections": "సామాజిక సంబంధాలు",

    // Growth & Development
    "natural_evolution": "సహజ పరిణామ మార్గం",
    "growth_potential": "వృద్ధి సంభావ్యత",
    "development_areas": "అభివృద్ధి రంగాలు",
    "transformation_capacity": "రూపాంతర సామర్థ్యం",
    "learning_opportunities": "అభ్యాస అవకాశాలు",
    "self_improvement": "స్వీయ అభివృద్ధి రంగాలు",

    // Seasonal Nature
    "seasonal_influences": "కాలానుగుణ ప్రభావాలు",
    "cyclical_patterns": "చక్రీయ నమూనాలు",
    "natural_rhythms": "సహజ లయలు",
    "biorhythms": "వ్యక్తిగత జీవ లయలు",
    "energy_cycles": "శక్తి చక్రాలు",
    "mood_cycles": "మానసిక స్థితి చక్రాలు",

    // Environmental Nature
    "environmental_preferences": "పర్యావరణ ప్రాధాన్యతలు",
    "natural_habitat": "సహజ నివాసం",
    "climate_preferences": "వాతావరణ ప్రాధాన్యతలు",
    "space_requirements": "స్థల అవసరాలు",
    "comfort_zones": "సౌకర్య ప్రాంతాలు",
    "optimal_environments": "అనువైన వాతావరణాలు",

    // Communication Nature
    "expression_style": "వ్యక్తీకరణ శైలి",
    "listening_style": "వినికిడి శైలి",
    "verbal_patterns": "మౌఖిక నమూనాలు",
    "non_verbal_communication": "అమౌఖిక కమ్యూనికేషన్",
    "communication_barriers": "కమ్యూనికేషన్ అవరోధాలు",
    "effective_communication": "ప్రభావవంతమైన కమ్యూనికేషన్ చిట్కాలు",

    // Stress & Relaxation
    "stress_patterns": "ఒత్తిడి నమూనాలు",
    "stress_responses": "ఒత్తిడి స్పందనలు",
    "relaxation_needs": "విశ్రాంతి అవసరాలు",
    "recovery_methods": "రికవరీ పద్ధతులు",
    "self_care_nature": "స్వీయ సంరక్షణ స్వభావం",
    "wellness_approaches": "ఆరోగ్య దృక్పథాలు",

    // Creative Nature
    "creative_expression": "సృజనాత్మక వ్యక్తీకరణ",
    "artistic_inclinations": "కళాత్మక ప్రవృత్తులు",
    "innovation_style": "ఆవిష్కరణ శైలి",
    "creative_processes": "సృజనాత్మక ప్రక్రియలు",
    "inspiration_sources": "ప్రేరణ మూలాలు",
    "creative_blocks": "సృజనాత్మక అడ్డంకులు మరియు పరిష్కారాలు"
};
